import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="flex flex-col justify-start items-center gap-y-5 mb-32">
      <h1 className="mt-3 font-bold text-3xl capitalize w-96">
        privacy policy
      </h1>
      <p className="w-96 text-sm">
        This privacy policy will explain how Poke Price uses the personal data
        we collect from you when you use our website.
      </p>
      <h2 className="font-bold text-md capitalize w-96">
        What data do we collect?
      </h2>
      <p className="w-96 text-sm">
        We collect the following data when you sign up or contact us:
      </p>
      <ul className="list-disc ml-14 w-96">
        <li>Email address</li>
      </ul>
      <h2 className="font-bold text-md capitalize w-96">
        How do we collect your data?
      </h2>
      <p className="w-96 text-sm">
        You directly provide Poke Price all of the data we collect. We collect
        data and process data when you:
      </p>
      <ul className="list-disc ml-14 w-96">
        <li>Sign up</li>
        <li>Save a request</li>
        <li>
          Add an OAuth connection to to Google Ads, Facebook Ads or another
          service
        </li>
        <li>Contact us through the contact form</li>
      </ul>
      <h2 className="font-bold text-md capitalize w-96">
        How will we use your data?
      </h2>
      <p className="w-96 text-sm">
        Poke Price collects your data so that we can:
      </p>
      <ul className="list-disc ml-14 w-96">
        <li>Save your favourites</li>
        <li>Save your favourites</li>
        <li>
          Email you about your requests, feature updates and helpful information
        </li>
      </ul>
      <h2 className="font-bold text-md capitalize w-96">
        How do we store your data?
      </h2>
      <p className="w-96 text-sm">We store your data in the following ways:</p>
      <ul className="list-disc ml-14 w-96">
        <li>
          Poke Price will keep your data for 20 years. Once this time period has
          expired, we will delete your data by deleting it on the server. If you
          delete your account your data will be deleted immediately.
        </li>
        <li>
          Poke Price stores all data in our servers and in storage within the
          browser.
        </li>
      </ul>
      <h2 className="font-bold text-md capitalize w-96">Marketing</h2>
      <p className="w-96 text-sm">
        Poke Price would like to send you information about products and
        services of ours that we think you might like. If you have agreed to
        receive marketing, you may always opt out at a later date.
      </p>
      <p className="w-96 text-sm">
        You have the right at any time to stop Poke Price from contacting you
        for marketing purposes. If you no longer wish to be contacted for
        marketing purposes, please click the unsubscribe link in the emails, or
        contact us.
      </p>
      <h2 className="font-bold text-md capitalize w-96">
        What are your data protection rights?
      </h2>
      <p className="w-96 text-sm">
        Poke Price would like to make sure you are fully aware of all of your
        data protection rights. Every user is entitled to the following:
      </p>
      <ul className="list-disc ml-14 w-96">
        <li>
          The right to access - You have the right to request Poke Price for
          copies of your personal data. We may charge you a small fee for this
          service.
        </li>
        <li>
          The right to rectification - You have the right to request that Poke
          Price correct any information you believe is inaccurate. You also have
          the right to request Poke Price to complete information you believe is
          incomplete.
        </li>
        <li>
          The right to erasure — You have the right to request that Poke Price
          erase your personal data, under certain conditions.
        </li>
        <li>
          The right to restrict processing - You have the right to request that
          Poke Price restrict the processing of your personal data, under
          certain conditions.
        </li>
        <li>
          The right to object to processing - You have the right to object to
          Poke Price’s processing of your personal data, under certain
          conditions.
        </li>
        <li>
          The right to data portability - You have the right to request that
          Poke Price transfer the data that we have collected to another
          organisation, or directly to you, under certain conditions.
        </li>
      </ul>
      <p className="w-96 text-sm">
        If you make a request, we have one month to respond to you. If you would
        like to exercise any of these rights, please contact us.
      </p>
      <h2 className="font-bold text-md capitalize w-96">What are cookies?</h2>
      <p className="w-96 text-sm">
        Cookies are text files placed on your computer to collect standard
        Internet log information and visitor behaviour information.
      </p>
      <p className="w-96 text-sm">
        When you visit our websites, we may collect information from you
        automatically through cookies or similar technology. For further
        information, visit: allaboutcookies.org
      </p>
      <h2 className="font-bold text-md capitalize w-96">
        How do we use cookies?
      </h2>
      <p className="w-96 text-sm">
        Poke Price uses cookies in a range of ways to improve your experience on
        our website, including:
      </p>
      <ul className="list-disc ml-14 w-96">
        <li>Understanding how you use our website</li>
      </ul>
      <h2 className="font-bold text-md capitalize w-96">
        What types of cookies do we use?
      </h2>
      <p className="w-96 text-sm">What types of cookies do we use?</p>
      <ul className="list-disc ml-14 w-96">
        <li>
          Authentication - Poke Price uses this cookie to persist your session.
          E.g. if you are logged in and you refresh you will stay logged in
          because of this cookie.
        </li>
        <li>
          Google Analytics - Find out about Google Analytics cookies{" "}
          <div>here</div>
        </li>
      </ul>
      <h2 className="font-bold text-md capitalize w-96">
        How to manage cookies?
      </h2>
      <p className="w-96 text-sm">
        You can set your browser not to accept cookies, and the above website
        tells you how to remove cookies from your browser. However, in a few
        cases, some of our website features may not function as a result.
      </p>
      <h2 className="font-bold text-md capitalize w-96">
        Privacy policies of other websites
      </h2>
      <p className="w-96 text-sm">
        The Poke Price website contains links to other websites. Our privacy
        policy applies only to our website, so if you click on a link to another
        website, you should read their privacy policy.
      </p>
      <h2 className="font-bold text-md capitalize w-96">
        Changes to our privacy policy
      </h2>
      <p className="w-96 text-sm">
        Poke Price keeps its privacy policy under regular review and places any
        updates on this web page. This privacy policy was last updated on 25
        February 2021.
      </p>
      <h2 className="font-bold text-md capitalize w-96">How to contact us</h2>
      <p className="w-96 text-sm">
        If you have any questions about Poke Price’s privacy policy, the data we
        hold on you, or you would like to exercise one of your data protection
        rights, please do not hesitate to contact us.
      </p>
      <h2 className="font-bold text-md capitalize w-96">
        How to contact the appropriate authority
      </h2>
      <p className="w-96 text-sm">
        Should you wish to report a complaint or if you feel that Poke Price has
        not addressed your concern in a satisfactory manner, you may contact the
        Information Commissioner’s Office:
      </p>
    </div>
  );
};

export default PrivacyPolicy;
